import React, { useState } from "react";
import ModernHero from "../components/Hero/ModernHero";
import CoinsTable from "../components/CoinsTable";
import TradingDashboard from "../components/TradingDashboard";
import TechnicalAnalysisPanel from "../components/TechnicalAnalysisPanel";
import TradingInsights from "../components/TradingInsights";
import ModernFooter from "../components/Footer/ModernFooter";
import MarketingSection from "../components/MarketingSection";
import WalletModal from "../components/WalletModal";
import SmartContractIntegration from "../components/SmartContractIntegration";
import DEXIntegration from "../components/DEXIntegration";
import AuditTransparency from "../components/AuditTransparency";

const Homepage = () => {
  const [selectedCoin, setSelectedCoin] = useState(null);

  const handleCoinSelect = (coin) => {
    setSelectedCoin(coin);
  };

  return (
    <>
      <WalletModal />
      <ModernHero />
      <SmartContractIntegration />
      <DEXIntegration />
      <AuditTransparency />
      <TradingDashboard />
      <CoinsTable onCoinSelect={handleCoinSelect} />
      <TechnicalAnalysisPanel selectedCoin={selectedCoin} />
      <TradingInsights />
      <MarketingSection />
      <ModernFooter />
    </>
  );
};

export default Homepage;
